<div class="h-screen h-dvh flex overflow-hidden bg-slate-50 text-slate-900 font-sans admin-layout-enter">

  <!-- Desktop Sidebar -->
  <aside [class.w-64]="!isCollapsed" [class.w-20]="isCollapsed"
    class="hidden md:flex flex-col fixed inset-y-0 left-0 z-30 bg-white border-r border-slate-200 transition-all duration-300 shadow-sm overflow-x-hidden">

    <!-- Sidebar Header (Logo Section) -->
    <div class="h-[70px] flex items-center border-b border-slate-200 justify-between select-none overflow-hidden"
      [class.px-5]="!isCollapsed" [class.px-3]="isCollapsed">
      <div class="flex items-center gap-0 min-w-0">
        <img
          [src]="isCollapsed ? 'images/logo-faisen/logo-n-faisen.png' : 'images/logo-faisen/logo-faisen.png'"
          alt="Faisen Logo"
          class="w-auto max-w-full rounded-xl object-contain drop-shadow-md hover:scale-105 transition-transform"
          [class.h-12]="!isCollapsed" [class.h-10]="isCollapsed" />
      </div>
    </div>

    <!-- Navigation Menu Items -->
    <nav class="flex-1 py-3 px-3 overflow-y-auto overflow-x-hidden scrollbar-thin select-none space-y-1">
      <div *ngFor="let item of filteredMenuItems()" class="relative group"
        (mouseenter)="onMouseEnterItem(item, $event)" (mouseleave)="onMouseLeaveItem()">

        <!-- Rótulo de zona: esta sucursal / todo el negocio -->
        <p *ngIf="item.sectionStart && !isCollapsed"
          class="px-2.5 pt-3 pb-1 text-2xs font-bold uppercase tracking-wide select-none"
          [class.text-primary-600]="item.scope === 'platform'" [class.text-slate-500]="item.scope === 'catalog'">
          {{ item.sectionStart }}
        </p>
        <div *ngIf="item.sectionStart && isCollapsed && item.scope === 'catalog'" class="my-2 mx-2 border-t border-slate-200"></div>

        <!-- Standard Menu Link (No Children) -->
        <a *ngIf="!item.children" [routerLink]="item.route"
          routerLinkActive="!bg-primary-500 !text-white hover:!bg-primary-600 hover:!text-white shadow-md shadow-primary-500/20 font-bold"
          class="flex items-center gap-2.5 py-2 px-2.5 rounded-xl text-slate-600 hover:text-slate-900 hover:bg-slate-50 transition-colors duration-150 cursor-pointer select-none">
          <div class="w-7 h-7 rounded-lg flex items-center justify-center shrink-0"
            [class.bg-slate-100]="!isMenuOrChildActive(item)">
            <i [class]="item.icon + ' text-xs'"></i>
          </div>
          <span class="text-xs font-bold truncate"
            [class.opacity-0]="isCollapsed" [class.pointer-events-none]="isCollapsed">
            {{ item.label }}
          </span>
        </a>

        <!-- Parent Menu Item with Submenu (Has Children) -->
        <div *ngIf="item.children" (click)="toggleSubmenu(item.id, $event)"
          [class.bg-primary-50]="isMenuOrChildActive(item) || (isSubmenuExpanded(item.id) && !isCollapsed)"
          [class.text-primary-700]="isMenuOrChildActive(item) || (isSubmenuExpanded(item.id) && !isCollapsed)"
          [class.font-bold]="isMenuOrChildActive(item)"
          class="flex items-center justify-between py-2 px-2.5 rounded-xl text-slate-600 hover:text-slate-900 hover:bg-slate-50 transition-colors duration-150 cursor-pointer w-full select-none">
          <div class="flex items-center gap-2.5 min-w-0">
            <div class="w-7 h-7 rounded-lg flex items-center justify-center shrink-0"
              [class.bg-primary-100]="isMenuOrChildActive(item)"
              [class.text-primary-600]="isMenuOrChildActive(item)"
              [class.bg-slate-100]="!isMenuOrChildActive(item)"
              [class.text-slate-500]="!isMenuOrChildActive(item)">
              <i [class]="item.icon + ' text-xs'"></i>
            </div>
            <span class="text-xs font-bold truncate"
              [class.opacity-0]="isCollapsed" [class.pointer-events-none]="isCollapsed">
              {{ item.label }}
            </span>
          </div>
          <!-- Arrow Icon for Submenus -->
          <i *ngIf="!isCollapsed" class="pi pi-chevron-right text-2xs text-slate-400 transition-transform duration-200 shrink-0 ml-1.5"
            [class.rotate-90]="isSubmenuExpanded(item.id)"
            [class.text-primary-600]="isMenuOrChildActive(item)"></i>
        </div>

        <!-- Submenu Children -->
        <div *ngIf="item.children && isSubmenuExpanded(item.id) && !isCollapsed"
          class="ml-4 pl-2.5 border-l-2 border-slate-100 space-y-0.5 mt-1">
          <a *ngFor="let child of item.children" [routerLink]="child.route" [queryParams]="child.queryParams"
            routerLinkActive="!bg-primary-50 !text-primary-600 !font-bold"
            [routerLinkActiveOptions]="{ paths: 'exact', queryParams: child.queryParams ? 'exact' : 'ignored', matrixParams: 'ignored', fragment: 'ignored' }"
            class="flex items-center py-1.5 px-2.5 rounded-lg text-slate-500 hover:text-slate-900 hover:bg-slate-50 text-xs font-semibold transition-colors duration-150">
            <span class="truncate">{{ child.label }}</span>
          </a>
        </div>

      </div>
    </nav>
  </aside>

  <!-- Fixed Hover Tooltip (Shown next to collapsed sidebar for items without children) -->
  <div *ngIf="isCollapsed && hoveredItemForTooltip" [ngClass]="{
      'bg-primary-500 text-white border-primary-500 shadow-md shadow-primary-500/20': isMenuOrChildActive(hoveredItemForTooltip),
      'bg-slate-800 text-white border-slate-700 shadow-md': !isMenuOrChildActive(hoveredItemForTooltip)
    }"
    class="fixed left-20 z-50 text-xs font-semibold px-3 py-2 rounded-lg border pointer-events-none whitespace-nowrap"
    [style.top.px]="tooltipTop">
    {{ hoveredItemForTooltip.label }}
    <!-- Arrow -->
    <div [ngClass]="{
        'bg-primary-500 border-primary-500': isMenuOrChildActive(hoveredItemForTooltip),
        'bg-slate-800 border-slate-700': !isMenuOrChildActive(hoveredItemForTooltip)
      }"
      class="absolute left-[-4px] top-1/2 -translate-y-1/2 w-2 h-2 border-l border-b rotate-45">
    </div>
  </div>

  <!-- Floating Submenu Panel (Shown next to collapsed sidebar on hover/click of submenu parent items) -->
  <div *ngIf="isCollapsed && activeOverlayMenu" (mouseenter)="onOverlayMouseEnter()"
    (mouseleave)="onOverlayMouseLeave()"
    class="fixed left-20 z-50 bg-white border border-slate-200 rounded-2xl shadow-xl py-3 w-56 animate-fade-in-left"
    [style.top.px]="overlayTop">
    <div class="px-4 pb-2 border-b border-slate-200 mb-2">
      <span class="text-xs uppercase font-bold text-primary-500 tracking-wider">{{
        activeOverlayMenu.label }}</span>
    </div>
    <div class="px-2 space-y-1">
      <a *ngFor="let child of activeOverlayMenu.children" [routerLink]="child.route" [queryParams]="child.queryParams" (click)="activeOverlayMenu = null"
        routerLinkActive="bg-primary-50 !text-primary-500 font-bold"
        [routerLinkActiveOptions]="{ paths: 'exact', queryParams: child.queryParams ? 'exact' : 'ignored', matrixParams: 'ignored', fragment: 'ignored' }"
        class="flex items-center py-1.5 px-2.5 rounded-lg text-slate-600 hover:text-slate-900 hover:bg-slate-100 text-xs font-semibold transition-colors duration-150">
        <span class="truncate">{{ child.label }}</span>
      </a>
    </div>
    <div class="absolute left-[-6px] top-5 w-3 h-3 bg-white border-l border-b border-slate-200 rotate-45">
    </div>
  </div>

  <!-- Mobile Sidebar / Drawer (Overlay on screen size < md) -->
  <div *ngIf="showMobileMenu" (click)="toggleMobileMenu()"
    class="md:hidden fixed inset-0 z-40 bg-slate-900/40 backdrop-blur-xs animate-fade-in">
  </div>
  <aside [class.translate-x-0]="showMobileMenu" [class.-translate-x-full]="!showMobileMenu"
    class="md:hidden fixed inset-y-0 left-0 z-50 w-72 bg-white border-r border-slate-200 transition-transform duration-300 flex flex-col shadow-2xl">

    <!-- Mobile Sidebar Header -->
    <div class="h-[70px] flex items-center px-6 border-b border-slate-200 justify-between">
      <div class="flex items-center gap-3">
        <img src="images/logo-faisen/logo-n-faisen.png" alt="Faisen Logo"
          class="w-10 h-10 rounded-xl object-contain drop-shadow-sm" ngSkipImageOptimization />
        <div class="flex flex-col">
          <span class="text-slate-900 font-extrabold text-base tracking-wider">FAISEN</span>
          <span
            class="text-2xs text-secondary tracking-[0.2em] font-semibold uppercase leading-none">Superadmin</span>
        </div>
      </div>
      <button (click)="toggleMobileMenu()"
        class="text-slate-500 hover:text-slate-900 p-2 rounded-lg hover:bg-slate-100 transition-colors">
        <i class="pi pi-times text-lg"></i>
      </button>
    </div>

    <!-- Mobile Navigation Items -->
    <nav class="flex-1 py-3 px-3 overflow-y-auto space-y-1">
      <div *ngFor="let item of filteredMenuItems()" class="my-0.5">
        <p *ngIf="item.sectionStart"
          class="px-2.5 pt-3 pb-1 text-2xs font-bold uppercase tracking-wide select-none"
          [class.text-primary-600]="item.scope === 'platform'" [class.text-slate-500]="item.scope === 'catalog'">
          {{ item.sectionStart }}
        </p>
        <!-- Direct route item -->
        <a *ngIf="!item.children" [routerLink]="item.route"
          (click)="showMobileMenu = false"
          routerLinkActive="!bg-primary-500 !text-white hover:!bg-primary-600 hover:!text-white shadow-md shadow-primary-500/20 font-bold"
          class="flex items-center gap-2.5 py-2 px-2.5 rounded-xl text-slate-600 hover:text-slate-900 hover:bg-slate-100 transition-colors duration-150">
          <div class="w-7 h-7 rounded-lg bg-slate-100 flex items-center justify-center shrink-0">
            <i [class]="item.icon + ' text-xs'"></i>
          </div>
          <span class="font-bold text-xs">{{ item.label }}</span>
        </a>

        <!-- Submenu trigger -->
        <div *ngIf="item.children">
          <div (click)="toggleSubmenu(item.id, $event)"
            [class.bg-primary-50]="isMenuOrChildActive(item) || isSubmenuExpanded(item.id)"
            [class.text-primary-700]="isMenuOrChildActive(item) || isSubmenuExpanded(item.id)"
            [class.font-bold]="isMenuOrChildActive(item)"
            class="flex items-center justify-between py-2 px-2.5 rounded-xl text-slate-600 hover:text-slate-900 hover:bg-slate-100 transition-colors duration-150 cursor-pointer">
            <div class="flex items-center gap-2.5 min-w-0">
              <div class="w-7 h-7 rounded-lg flex items-center justify-center shrink-0"
                [class.bg-primary-100]="isMenuOrChildActive(item)"
                [class.text-primary-600]="isMenuOrChildActive(item)"
                [class.bg-slate-100]="!isMenuOrChildActive(item)"
                [class.text-slate-500]="!isMenuOrChildActive(item)">
                <i [class]="item.icon + ' text-xs'"></i>
              </div>
              <span class="font-bold text-xs truncate">{{ item.label }}</span>
            </div>
            <i class="pi pi-chevron-right text-2xs text-slate-400 transition-transform"
              [class.rotate-90]="isSubmenuExpanded(item.id)"
              [class.text-primary-600]="isMenuOrChildActive(item)"></i>
          </div>

          <div *ngIf="isSubmenuExpanded(item.id)" class="ml-4 pl-2.5 border-l-2 border-slate-100 space-y-0.5 mt-1">
            <a *ngFor="let child of item.children" [routerLink]="child.route" [queryParams]="child.queryParams"
              (click)="showMobileMenu = false"
              routerLinkActive="!bg-primary-50 !text-primary-600 !font-bold"
              [routerLinkActiveOptions]="{ paths: 'exact', queryParams: child.queryParams ? 'exact' : 'ignored', matrixParams: 'ignored', fragment: 'ignored' }"
              class="flex items-center py-1.5 px-2.5 rounded-lg text-slate-500 hover:text-slate-900 hover:bg-slate-50 text-xs font-semibold transition-colors">
              <span class="truncate">{{ child.label }}</span>
            </a>
          </div>
        </div>
      </div>
    </nav>
  </aside>

  <!-- Layout Wrapper (Takes remaining space) -->
  <div [class.md:pl-64]="!isCollapsed" [class.md:pl-20]="isCollapsed"
    class="flex-1 flex flex-col transition-all duration-300 h-full overflow-hidden min-w-0">

    <!-- Header Section -->
    <header
      class="shrink-0 z-20 h-[70px] bg-white border-b border-slate-200 flex items-center justify-between px-6 transition-colors duration-300">

      <!-- Left side: Hamburger and Section title -->
      <div class="flex items-center gap-4">
        <!-- Desktop toggle -->
        <button (click)="toggleSidebar()"
          class="hidden md:flex w-10 h-10 rounded-xl items-center justify-center text-slate-500 hover:bg-slate-100 hover:text-primary-500 transition-all">
          <i class="pi pi-bars text-lg"></i>
        </button>
        <!-- Mobile toggle -->
        <button (click)="toggleMobileMenu()"
          class="md:hidden w-10 h-10 rounded-xl flex items-center justify-center text-slate-500 hover:bg-slate-100 hover:text-primary-500 transition-all">
          <i class="pi pi-bars text-lg"></i>
        </button>

        <!-- Breadcrumb / Section Label -->
        <div class="flex items-center gap-2 select-none">
          <span class="text-xs uppercase tracking-wider text-slate-400 font-semibold hidden sm:inline">FAISEN</span>
          <span class="text-xs text-slate-300 hidden sm:inline">/</span>
          <span class="text-sm font-bold text-slate-900 uppercase tracking-wide">
            {{ currentPageLabel }}
          </span>
        </div>
      </div>

      <!-- Right side: Notifications, Profile -->
      <div class="flex items-center gap-4">

        <!-- Notification Bell -->
        <!-- <button -->
          <!-- class="relative w-10 h-10 rounded-xl flex items-center justify-center text-slate-500 hover:bg-slate-100 hover:text-primary-500 transition-all"> -->
          <!-- <i class="pi pi-bell text-lg"></i> -->
          <!-- Glowing notification dot -->
          <!-- <span -->
            <!-- class="absolute top-2.5 right-2.5 w-2 h-2 bg-danger-500 rounded-full border border-white animate-pulse"></span> -->
        <!-- </button> --> 

        <!-- Vertical Divider -->
        <div class="h-6 w-[1px] bg-slate-200"></div>

        <!-- User Profile Dropdown Component -->
        <div class="relative">
          <button (click)="toggleProfileMenu()"
            class="flex items-center gap-3 text-left focus:outline-none hover:opacity-90 transition-opacity">
            <!-- Initials Avatar Grid -->
            <div
              class="w-10 h-10 rounded-xl bg-gradient-to-br from-primary-500 to-secondary flex items-center justify-center text-white font-extrabold text-sm shadow-sm shadow-primary-500/10">
              {{ currentUser.initials }}
            </div>
            <!-- Name & Role (Hidden on mobile) -->
            <div class="hidden sm:flex flex-col select-none pr-1">
              <span class="text-sm font-bold text-slate-900 leading-tight">{{ currentUser.name
                }}</span>
              <span class="text-2xs text-slate-500 font-semibold leading-none">{{ currentUser.role }}</span>
            </div>
            <i class="pi pi-chevron-down text-slate-400 text-xs hidden sm:block transition-transform duration-300"
              [class.rotate-180]="showProfileMenu"></i>
          </button>

          <!-- Profile Options Dropdown Menu -->
          <div *ngIf="showProfileMenu" (click)="showProfileMenu = false"
            class="absolute right-0 mt-3 w-52 bg-white border border-slate-200 rounded-2xl shadow-xl py-2 animate-fade-in z-50">
            <div class="px-4 py-2 border-b border-slate-200 sm:hidden">
              <p class="text-sm font-bold text-slate-900 leading-tight">{{ currentUser.name }}</p>
              <p class="text-xs text-slate-500 font-medium mt-0.5">{{ currentUser.role }}</p>
            </div>
            <a routerLink="/admin/profile"
              class="flex items-center gap-3 px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-50 hover:text-primary-500 transition-colors">
              <i class="pi pi-user text-sm"></i>
              <span>Mi Perfil</span>
            </a>
            <div class="h-[1px] bg-slate-200 my-1"></div>
            <button (click)="confirmLogout()"
              class="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-danger-600 hover:bg-danger-50 transition-colors text-left">
              <i class="pi pi-sign-out text-sm"></i>
              <span>Cerrar Sesión</span>
            </button>
          </div>
        </div>

      </div>
    </header>

    <!-- Main Content Outlet Area -->
    <main class="flex-1 p-6 lg:p-8 overflow-y-auto">
      <router-outlet></router-outlet>
    </main>

    <!-- Admin Footer -->
    <footer
      class="bg-white border-t border-slate-200 px-6 py-4 flex flex-col sm:flex-row items-center justify-between text-xs text-slate-500 font-medium select-none transition-colors duration-300">
      <span>© 2026 <a href="/" target="_blank" class="hover:text-primary-500 transition-colors font-bold">FAISEN</a>.
        Todos los derechos
        reservados.</span>
      <div class="flex gap-4 mt-2 sm:mt-0">
        <a class="hover:text-primary-500 cursor-pointer">Soporte</a>
        <span>·</span>
        <a class="hover:text-primary-500 cursor-pointer">Términos y Privacidad</a>
      </div>
    </footer>

    <!-- ─── Visor Global de Imágenes (disponible en toda la app) ─── -->
    <app-image-viewer></app-image-viewer>

  </div>

  <!-- Confirm Dialog: Cerrar Sesión -->
  <app-logout-confirm [(visible)]="showLogoutConfirm" (confirmed)="logout()"></app-logout-confirm>

</div>